import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {PlatformIdentityService} from '../services/auth/identity/platform-identity.service';

@Injectable({
  providedIn: 'root',
})
export class InternalAdminGuard implements CanActivate {
  private readonly identity = inject(PlatformIdentityService);
  private readonly router = inject(Router);

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const allowed = this.identity.isPlatformAdmin;

    if (allowed) return true;

    this.router.navigateByUrl('/ai/dashboard');
    return false;
  }
}

